"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileUrl = void 0;
var getFileUrl_1 = require("./getFileUrl");
Object.defineProperty(exports, "getFileUrl", { enumerable: true, get: function () { return __importDefault(getFileUrl_1).default; } });
